import React, { useEffect, useState } from 'react';
import { Box, Paragraph } from 'theme-ui';
import { Svg, Link } from '@snippets';
import { theme } from '../../../../../theme';
import { themed } from './AfterPay.theme';

// export function AfterPay({ price, variantId, currency, themeSettings }) {
export const AfterPay = themed(
  ({ theme: themeSettings, price, variantId, currency }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
      setMounted(true);
    }, [variantId]);

    const handleClick = (evt) => {
      if (typeof Afterpay === 'object') {
        evt.preventDefault();
        window.Afterpay.launchModal('en_US-theme-white');
      }
    };
    if (!mounted)
      return <div className="bg-background absolute inset-0 h-full bg-white" />;

    return price >= 35 ? (
      <div className="relative -mt-1 md:mt-0 flex items-baseline text-[#8C8C8D]">
        <afterpay-placement
          data-locale="en_US"
          data-currency={currency || 'USD'}
          data-amount={price}
          data-modal-theme="white"
          data-logo-type="compact-badge"
          data-modal-link-style="none"
          id="after-pay"
          data-intro-text="Pay in"
        />

        {/* Hide unstyled afterpay logo during initial load */}
        {!mounted && (
          <div className="bg-background absolute inset-0 h-full bg-white" />
        )}
        <style>
          {`afterpay-placement{
            margin: 0;
            color: ${theme.colors.mediumDarkGray};
            --messaging-font-size: ${theme.fontSizes[4]};
            --logo-badge-width: 62px;
          }
          @media (max-width: 767px) {
            afterpay-placement{
              --messaging-font-size: ${theme.fontSizes[3]};
              --logo-badge-width: 56px;
            }
          }
        `}
        </style>
      </div>
    ) : (
      <>
        <Paragraph sx={themeSettings.afterpay.text}>
          Interest-free installments by
        </Paragraph>
        <Link
          href="https://www.afterpay.com/en-US/terms-of-service"
          newTab
          sx={themeSettings.afterpay.link}
          onClick={handleClick}
        >
          <Box sx={themeSettings.afterpay.pill}>
            <Svg
              alt="afterpay"
              src="/svgs/afterpay.svg"
              viewBox="0 0 98 24"
              sx={themeSettings.afterpay.logo}
            />
          </Box>
        </Link>
      </>
    );
  }
);
